import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { api } from "../lib/api";
import { IMAGES } from "../lib/images";

export default function MediaPage() {
  const [press, setPress] = useState([]);
  useEffect(() => { api.get("/press").then((r) => setPress(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <SEO title="Press" description="News, press releases, and media coverage from Elliott International Development." path="/media" />
      <section className="relative pt-40 pb-16 px-6 lg:px-12">
        <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="overline">— Newsroom</div>
            <div className="overline mt-2 text-foreground/50">Press · Releases · Coverage</div>
          </div>
          <div className="lg:col-span-8">
            <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }} className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.98] font-light tracking-tight">
              In the <em className="text-primary italic">press.</em>
            </motion.h1>
          </div>
        </div>
      </section>

      <section className="px-6 lg:px-12 pb-32">
        <div className="max-w-[1200px] mx-auto mt-20 divide-y divide-primary/10 border-t border-primary/10">
          {press.map((p, i) => (
            <motion.a
              key={p.id}
              href={p.url}
              target="_blank"
              rel="noreferrer noopener"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              data-testid={`press-article-${p.id}`}
              className="group block py-10 hover:bg-card/40 transition-colors px-2 -mx-2"
            >
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
                <div className="md:col-span-2 font-mono text-xs text-primary">
                  <div>{new Date(p.date).getFullYear()}</div>
                  <div className="text-foreground/50">{new Date(p.date).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</div>
                </div>
                <div className="md:col-span-3 overline text-foreground/60">{p.outlet}</div>
                <div className="md:col-span-6">
                  <h3 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight group-hover:text-primary transition-colors">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{p.excerpt}</p>
                </div>
                <div className="md:col-span-1 flex justify-end">
                  <ArrowUpRight className="w-5 h-5 text-primary transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </section>

      <section className="px-6 lg:px-12 pb-32">
        <div className="max-w-[1600px] mx-auto relative overflow-hidden">
          <img src={IMAGES.construction_site} alt="Construction" className="w-full aspect-[16/7] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
          <div className="absolute bottom-10 left-10 right-10">
            <div className="overline mb-4">— Media Inquiries</div>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight">press@elliottdev.com</h2>
          </div>
        </div>
      </section>
    </Layout>
  );
}
